// extracted by mini-css-extract-plugin
export default {"banner":"HomeBanner_banner__PaKGd","texts":"HomeBanner_texts__Jj9Yg","imgs":"HomeBanner_imgs__2WiaG"};